var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPlusinline = function SvgPlusinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 12c0 .465-.38.846-.846.846h-9.308v9.307a.846.846 0 1 1-1.692 0v-9.307H1.846a.845.845 0 1 1 0-1.693h9.308V1.846a.845.845 0 1 1 1.692 0v9.307h9.308c.465 0 .846.381.846.846Z",
    fill: "#000"
  })));
};

export default SvgPlusinline;